<div class="d-flex justify-content-center spinner-div">
    <div class="spinner spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>